export default __webpack_public_path__ + "static/media/not-geozone.d59511f4.svg";